import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  getFolders: {
    method: 'GET',
    url: `${configs.baseUrl}/api/folder/`,
  },
  createFolder: {
    method: 'POST',
    url: `${configs.baseUrl}/api/folder`,
  },
  updateFolderById: {
    method: 'PATCH',
    url: `${configs.baseUrl}/api/folder/{folderId}`,
  },
  removeFolderById: {
    method: 'DELETE',
    url: `${configs.baseUrl}/api/folder/{folderId}`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const getFolders = async (params) => {
  const res = await resource.getFolders(params)
  return res.body.folders
}

const createFolder = async (params) => {
  const res = await resource.createFolder(params)

  return {
    code: res.body.code,
    folder: res.body.folder,
  }
}

const updateFolderById = (folderId, params) => {
  return resource.updateFolderById({ folderId }, params)
}

const removeFolderById = (folderId) => {
  return resource.removeFolderById({ folderId })
}

export default {
  initResource,
  getFolders,
  createFolder,
  updateFolderById,
  removeFolderById,
}
